import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ACTIONS = ["view", "create", "edit", "delete", "download"];

// Tabs (and sub-tabs) an associate / their employees can be given access to.
export const RIGHTS_CATALOG = [
  { key: "dashboard", label: "Dashboard", path: "/dashboard", subs: [
    ["overview", "Overview"], ["exited", "Exited"], ["elss_pending", "ELSS Pending"], ["mismatch", "Mismatch"],
    ["multi_broker", "Multi Broker"], ["outperformers", "Outperformers"], ["underperformers", "Underperformers"],
    ["profit_realignment", "Profit Realignment"], ["reduced_portfolio", "Reduced Portfolio"], ["historical_data", "Historical Data"],
    ["unpaid_brokerage", "Unpaid Brokerage"]] },
  { key: "client_wise", label: "Client Wise Summary", path: "/client-wise", subs: [
    ["all", "All"], ["aum", "AUM"], ["family_aum", "Family AUM"], ["with_pan", "With PAN"], ["without_pan", "Without PAN"],
    ["minor", "Minor"], ["sip", "SIP"], ["stp", "STP"], ["swp", "SWP"]] },
  { key: "portfolio", label: "Portfolio", path: "/portfolio", subs: [] },
  { key: "research", label: "Research", path: "/mf-schemes", subs: [] },
  { key: "leads", label: "Leads", path: "/leads", subs: [
    ["introduction", "Introduction"], ["kyc-information", "KYC Information"], ["asset-allocation", "Asset Allocation"],
    ["account-opening", "Account Opening"], ["mandate", "Mandate"], ["uploads", "Uploads"]] },
  { key: "downloads", label: "Downloads", path: "/downloads", subs: [] },
];

export const fullRights = () => Object.fromEntries(RIGHTS_CATALOG.map((t) => [t.key, {
  ...Object.fromEntries(ACTIONS.map((a) => [a, true])), subs: Object.fromEntries(t.subs.map(([k]) => [k, true])) }]));

export const can = (rights, tab, action = "view", sub) => {
  if (!rights) return true;
  const t = rights[tab];
  if (!t) return true;
  if (t[action] === false) return false;
  return !(sub && t.subs && t.subs[sub] === false);
};

export const locate = (pathname) => {
  const t = RIGHTS_CATALOG.find((x) => pathname === x.path || pathname.startsWith(`${x.path}/`));
  if (!t) return null;
  const sub = t.key === "leads" ? pathname.split("/")[3] : undefined;
  return { tab: t, sub };
};

let cache = null;
let pending = null;
export const useMyRights = (user) => {
  const scoped = ["sub_broker", "employee"].includes(user?.role);
  const [rights, setRights] = useState(scoped ? cache : null);
  useEffect(() => {
    if (!scoped) return;
    const token = localStorage.getItem("token");
    pending = pending || axios.get(`${API}/associate-extras/me/rights`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (cache = r.data.rights)).catch(() => null).finally(() => { pending = null; });
    pending.then((r) => setRights(r ?? cache));
  }, [scoped, user?.id]);
  return scoped ? rights : null;
};
